module.exports = __webpack_public_path__ + "img/s-mob-7.c1ddc90f.webp";